const pluginRegistry = {}
const pluginPromises = {}

export function registerPlugin(name, factory) {
  pluginRegistry[name] = factory
}

export function getPlugin(name) {
  const plugin = pluginRegistry[name]
  if (!plugin) {
    console.warn(`Simulation: plugin "${name}" not found in registry`)
  }
  return plugin
}

export function getPluginAsync(name) {
  // Return from cache if already registered synchronously
  if (pluginRegistry[name]) {
    return Promise.resolve(pluginRegistry[name])
  }

  // Return pending promise if already loading
  if (pluginPromises[name]) {
    return pluginPromises[name]
  }

  let loader
  switch (name) {
    case 'interactive-path':
      loader = import(/* webpackChunkName: "plugin-interactive-path" */ './interactivePathPlugin')
      break
    case 'spreadsheet':
      loader = import(/* webpackChunkName: "plugin-spreadsheet" */ './spreadsheetPlugin')
      break
    case 'intro-card':
      loader = import(/* webpackChunkName: "plugin-intro-card" */ './introCardPlugin')
      break
    case 'statement-table':
      loader = import(/* webpackChunkName: "plugin-statement-table" */ './statementTablePlugin')
      break
    case 'sorting':
      loader = import(/* webpackChunkName: "plugin-sorting" */ './sortingPlugin')
      break
    case 'code-editor':
      loader = import(/* webpackChunkName: "plugin-code-editor" */ './codeEditorPlugin')
      break
    case 'process-flow':
      loader = import(/* webpackChunkName: "plugin-process-flow" */ './processFlowPlugin')
      break
    case 'facility-planner':
      loader = import(/* webpackChunkName: "plugin-facility-planner" */ './facilityPlannerPlugin')
      break
    case 'matching':
      loader = import(/* webpackChunkName: "plugin-matching" */ './matchingPlugin')
      break
    case 'stakeholder-dialogue':
      loader = import(/* webpackChunkName: "plugin-stakeholder-dialogue" */ './stakeholderDialoguePlugin')
      break
    case 'inbox-triage':
      loader = import(/* webpackChunkName: "plugin-inbox-triage" */ './inboxTriagePlugin')
      break
    case 'performance-review':
      loader = import(/* webpackChunkName: "plugin-performance-review" */ './performanceReviewPlugin')
      break
    case 'training-designer':
      loader = import(/* webpackChunkName: "plugin-training-designer" */ './trainingDesignerPlugin')
      break
    default:
      return Promise.reject(new Error('Unknown plugin: ' + name))
  }

  pluginPromises[name] = loader.then(() => {
    // The dynamic import triggers the module's side-effect registerPlugin() call
    const factory = pluginRegistry[name]
    if (!factory) {
      throw new Error('Plugin "' + name + '" did not register itself after loading')
    }
    return factory
  })

  return pluginPromises[name]
}
